module.exports = __webpack_public_path__ + "static/media/Group 37398.acb6674c.png";